"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeroSectionModule = _interopRequireDefault(require("./HeroSection.module.css"));
var HeroSection = function HeroSection(props) {
  var contentSection = props.contentSection,
    imageSection = props.imageSection,
    contentWidthPercent = props.contentWidthPercent,
    inverseLayout = props.inverseLayout;
  var rightWidthPercent = 100 - contentWidthPercent;
  var HeroSectionClasses = "".concat(_HeroSectionModule["default"].HeroSection, " ").concat(inverseLayout ? _HeroSectionModule["default"].inverse : '');
  var contentStyles = {
    width: "".concat(contentWidthPercent, "%")
  };
  var imageStyles = {
    justifyContent: inverseLayout ? 'flex-start' : 'flex-end',
    width: "".concat(rightWidthPercent, "%")
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: HeroSectionClasses,
    "data-testid": "HeroSection"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _HeroSectionModule["default"].contentSection,
    style: contentStyles
  }, contentSection), /*#__PURE__*/_react["default"].createElement("div", {
    className: _HeroSectionModule["default"].imageSection,
    style: imageStyles
  }, imageSection));
};
HeroSection.defaultProps = {
  contentWidthPercent: 50,
  inverseLayout: false
};
var _default = HeroSection;
exports["default"] = _default;